export default "__VITE_ASSET__U5tg$sxl__"